import { createArray } from 'utils/helpers/create-fake-array';
import { Divider } from 'newcomponents/UI/Divider';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const RESULTS_TEMPLATE_COUNT = 5;

export const ResultsSkeleton = () => {
  return (
    <>
      <div className="marketStatistics__header">
        <div className="marketStatistics__header__title">
          <Skeleton
            active
            title={{
              style: { width: 200, height: 16, margin: '0' }
            }}
            paragraph={false}
          />
        </div>
      </div>
      <div className="resultsTemplate">
        <div className="marketStatisticsTemplateTabs">
          <Skeleton
            active
            title={{
              width: '100%',
              style: { height: 20, textAlign: 'center', margin: ' 0 auto' }
            }}
            paragraph={false}
            className="matchHeader__skeleton"
          />
        </div>
        <div className="resultsTemplate__statisticBox">
          <div className="previousMatches">
            <Skeleton
              active
              title={{
                width: 100,
                style: {
                  height: 17,
                  textAlign: 'center',
                  margin: ' 0 auto'
                }
              }}
              paragraph={false}
              className="matchHeader__skeleton"
            />
          </div>
          <div className="resultsTemplate__teamInfo">
            <div className="resultsTemplate__box">
              <div className="resultsTemplate__teamName">
                <Skeleton
                  active
                  title={{
                    width: 100,
                    style: {
                      height: 15,
                      textAlign: 'center',
                      margin: ' 0 auto'
                    }
                  }}
                  paragraph={false}
                  className="matchHeader__skeleton"
                />
              </div>
              <div className="resultsTemplate__boxes">
                {createArray(RESULTS_TEMPLATE_COUNT).map((item, i) => {
                  return (
                    <div className="statIcon" key={i}>
                      <Skeleton
                        active
                        title={{
                          width: 15,
                          style: { height: 15, textAlign: 'center', margin: 2 }
                        }}
                        paragraph={false}
                        className="matchHeader__skeleton"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <Divider
              type="vertical"
              distance={8}
              className="statisticBoxDivider"
            />
            <div className="resultsTemplate__box">
              <div className="resultsTemplate__teamName">
                <Skeleton
                  active
                  title={{
                    width: 100,
                    style: {
                      height: 15,
                      textAlign: 'center',
                      margin: ' 0 auto'
                    }
                  }}
                  paragraph={false}
                  className="matchHeader__skeleton"
                />
              </div>
              <div className="resultsTemplate__boxes">
                {createArray(RESULTS_TEMPLATE_COUNT).map((item, i) => {
                  return (
                    <div className="statIcon" key={i}>
                      <Skeleton
                        active
                        title={{
                          width: 15,
                          style: { height: 15, textAlign: 'center', margin: 2 }
                        }}
                        paragraph={false}
                        className="matchHeader__skeleton"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="marketStatistics__footer">
        <Skeleton
          active
          title={{
            style: { width: 150, height: 16, margin: '0' }
          }}
          paragraph={false}
        />
      </div>
    </>
  );
};
